import { render, staticRenderFns } from "./mapold.vue?vue&type=template&id=7bc8350e&scoped=true"
import script from "./mapold.vue?vue&type=script&lang=js"
export * from "./mapold.vue?vue&type=script&lang=js"
import style0 from "./mapold.vue?vue&type=style&index=0&id=7bc8350e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8350e",
  null
  
)

export default component.exports